/*
 *
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HospitalPayment from './hospital-payment';
import HospitalPaymentDetail from './hospital-payment-detail';
import HospitalPaymentUpdate from './hospital-payment-update';
import HospitalPaymentDeleteDialog from './hospital-payment-delete-dialog';

const HospitalPaymentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HospitalPayment />} />
    <Route path="new" element={<HospitalPaymentUpdate />} />
    <Route path=":id">
      <Route index element={<HospitalPaymentDetail />} />
      <Route path="edit" element={<HospitalPaymentUpdate />} />
      <Route path="delete" element={<HospitalPaymentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HospitalPaymentRoutes;
